module.exports = __webpack_public_path__ + "img/Mask Group 2887@2x.63778b9a.png";